import { fulfilled, failed, pending } from "lib/promiseMiddlewareTypes";
import initialState from "store/initialState";
import { GET_SUBJECTS } from "actions/subjects";

const subjects = (state = initialState.subjects, action: any) => {
  switch (action.type) {
    case failed(GET_SUBJECTS):
    case pending(GET_SUBJECTS):
      return [];
    case fulfilled(GET_SUBJECTS):
      return action.payload.sites;
    default:
      return state;
  }
};

export default subjects;
